<template>
    <div class="checkout">
        <div class="header flex" style="justify-content: flex-start">
            <v-icon
                color="#f3f3f2"
                class="ml-4"
                @click="removeWebViewFromAndroid"
                >mdi-arrow-left</v-icon
            >
            <p class="headerText">ऑर्डर जांचे और पेमेंट करें</p>
            <div style="height: 14px; background-color: #f3f3f2"></div>
        </div>

        <div class="whitebackgrnd">
            <div class="imageGrid flex">
                <div class="imageBox mr-4">
                    <img class="imgBorder" :src="orderDetails.productImage" />
                </div>

                <div class="desc">
                    <p
                        style="
                            margin-bottom: -1px;
                            font-weight: 600;
                           "
                    >
                        {{ orderDetails.productName }}
                    </p>
                    <p
                        style="
                            color: #a6aca9;
                            font-weight: 400;
                            font-size: 14px;
                        "
                        class="mt-1"
                    >
                        {{ orderDetails.productSize }}
                        {{ orderDetails.measuringUnit }}
                    </p>
                    <p
                    class="productPrice"
                        style="font-weight: 600;"
                        v-if="orderDetails.maxPrice&&orderDetails.sellingPrice"
                    >
                       &#8377; {{ orderDetails.sellingPrice }}
                        
                        <small style="color:#b97f67;text-decoration: line-through;font-weight:500">&#8377;{{ orderDetails.maxPrice }}</small>
                    </p>
                </div>
            </div>
            <div class="mt-4 buy">
                <p style="">
                   आप कितना खरीदना चाहते हैं?
                </p>
                <div
                    class="flex"
                    style="
                        justify-content: space-between;
                        padding: 0.6rem;
                        background-color: #FCF9F4;
                        border-radius: 4px;
                        margin: 0rem;
                    "
                >
                    <div class="ml-2" v-if="orderDetails.quantity">
                        <v-icon
                            size="30"
                            color="#000000"
                            :v-model="orderDetails.quantity"
                            @click="updateQuantity('minus')"
                            :disabled="orderDetails.quantity == 1"
                            >mdi-minus</v-icon
                        >
                    </div>
                    <div>
                        <h3>{{ orderDetails.quantity }}</h3>
                    </div>
                    <div class="mr-2">
                        <v-icon
                            :v-model="orderDetails.quantity"
                            @click="updateQuantity('add')"
                            size="30"
                            color="#000000"
                            >mdi-plus</v-icon
                        >
                    </div>
                </div>
                <div class="mt-0" style="justify-content: space-between">
                    <div class="flex" style="justify-content: space-between">
                        <p
                            style=""
                            class="mt-4 deliveryText"
                        >
                            डिलीवरी का पता
                        </p>
                       
                    </div>
                    <div
                        class="address"
                    >
                        <!-- <small style="font-size: 14px">{{
                            orderDetails.fullName
                        }}</small> -->
                        <small
                            v-html="orderDetails.address"
                            style="width: 80%,justify-content:flex-start"
                        >
                        </small>
                        <!-- <small>haryana, india</small> -->
                        <!-- <small> {{ orderDetails.phoneNo }}</small> -->
                        <div class="mt-4">
                            <v-form ref="CoupounRef">
                                <v-text-field
                                    outlined
                                    dense
                                    placeholder="CL कोड यहाँ दर्ज करें "
                                    full-width
                                    class="textBox"
                                    v-model="orderDetails.discountCoupon"
                                    @focus="onFocusInput"
                                   @input="onInput"
                                >
                                </v-text-field>
                              
                                <div class="flex" style="justify-content: end !important">
                                    <p
                                        v-if="orderDetails.coupounVerified==''||orderDetails.discountCoupon==null"
                                        @click="checkCoupounState('apply')"
                                        class="mr-4 mt-1 coupounBox"
                                        style="font-weight:600;font-size:16px"
                                        
                                    >
                                       अप्लाई करें
                                    </p>
                                    <p
                                        v-if="orderDetails.coupounVerified=='notValid'"
                                        @click="checkCoupounState('remove')"
                                        class="mr-4 mt-1 coupounBox"
                                        style="font-weight:600;font-size:16px;color: #b97f67"
                                        
                                    >
                                       <v-icon size='18' color='#b97f67'>mdi-window-close</v-icon>  हटाएं
                                    </p>
                                    <p
                                        v-if="orderDetails.coupounVerified=='valid'"
                                        @click="checkCoupounState('remove')"
                                        class="mr-4 mt-1 coupounBox"
                                        style="font-weight:600;font-size:16px"
                                    >
                                       <v-icon size='18' color='#005700' style="transform: translateY(-1px);;mrgin-bottom:4px;font-weight:600">mdi-check</v-icon> बदलें
                                    </p>
                                </div>
                            </v-form>
                        </div>
                        <div style="transform: translateY(-70px);" v-if="orderDetails.coupounVerified =='valid'">
                            <small style="color:#005700;font-weight:600">बधाई! कूपन अप्लाई हो गया है </small>
                        </div>
                        <div style="transform: translateY(-70px);" v-if="orderDetails.coupounVerified =='notValid'">
                            <small style="color:#70585b;font-weight:600">यह कूपन मान्य नहीं है </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex mb-4" style="background-color: #e3e3e3; margin-top: -56px">
            <p style="padding: 12px; margin: auto; color: #707070">
                पेमेंट समरी
            </p>
        </div>
        <payment-summary
            :data="orderDetails.calculationInfo"
            v-if="orderDetails.calculationInfo"
        />

        <div style="margin-bottom:14vh">
            <div>
                <div class="flex mt-4 ">
                    <div
                        class="flex mt-0 "
                        style="
                            width: calc(100vw - 40px);
                            background-color: #FCF9F4;
                        "
                    >
                        <div class="flex " style="margin: 0.6rem" >
                            <v-icon color="#70585B" style="margin-right: 12px"
                                >mdi-shield-check</v-icon
                            >

                            <p
                                style="font-size: 16px; width: 100%;border-radius:4px"
                                class="mt-4"
                            >
                                सुरक्षित पेमेंट || 24 घंटे में ऑडर केंसिल करने पर पाएं 5 -7 दिनों में आसानी से रिफंड || 100% ऑरिजिनल प्रोडक्ट्स
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="flex mb-0 payButton" style="background-color: white; margin-top: 0px;height:10vh">
            <!-- <p style="padding: 12px; margin: auto; color: #707070">
                पेमेंट समरी
            </p> -->
             <v-btn
                    width="95%"
                    height="50px"
                    style="color:white"
                    color="#005700 !important"
                    depressed
                    class="--weight mb-6 "
                    @click="razorpay"
                    :disabled='!isInitiated'
                    >{{ orderDetails.buttonText }}
                </v-btn>
        </div>
        <!-- <div  class="flex">
        <div class=" payButton" style="background-color:white">
            <div class="flex mt-1" style="">
                <v-btn
                    width="100%"
                    height="50px"
                    dark
                    color="#005700"
                    depressed
                    class="--weight"
                    @click="razorpay"
                    >{{ orderDetails.buttonText }}
                </v-btn>
            </div>
        </div>
        </div> -->
        <v-overlay opacity="0.3" color="black" v-if="loader">
            <v-progress-circular
                indeterminate
                color="#1F8F58"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import accessToken from "../../helpers/accessToken";
import API_URL from "../../helpers/apiUrls";
import rules from "../../helpers/rules";
import router from "../../router";
import paymentSummary from "./components/payment-summary.vue";
import MoengageEventGenerator from "../../helpers/moengageEventGenerator";
import MoengageEvents from "../../helpers/moengageEvents";
import MoengageAtrributes from "../../helpers/moengageAttributes";
export default {
    name: "checkout",

    components: {
        "payment-summary": paymentSummary,
    },

    data() {
        return {
            defaultImage: require("../../assets/MainDashboard/Products/DefaultImage.png"),
            orderId: null,
            loader: false,
            orderDetails: {
                productImage: null,
                productName: null,
                fullName: "",
                address: "",
                quantity: 1,
                productSize: null,
                measuringUnit: null,
                discountCoupon: null,
                phoneNo: null,
                productId: null,
                calculationInfo: null,
                payableAmount: null,
                totalAmount: null,
                buttonText: null,
                coupounVerified: '',
                orderId: null,
                maxPrice:null,
                sellingPrice:null,
                shortId:null
            },
            success: false,
            isInitiated:true,
            rules: rules,
            verified: false,
            appliedRules: [],
            transcationVerficationDetails: null,
            transactionDetails: { 
                key: null, // Enter the Key ID generated from the Dashboard
                amount: null, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                currency: null,
                name: 'Krishify',
                description: 'किसानों का नेटवर्किंग ऍप',
                image: require("../../assets/logo.svg"),
                order_id: null, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                callback_url: "",
                //redirect: true,
                handler: function (response) {
                    console.log(response);
                    window.location.replace(
                        `/payment-success/${response.razorpay_payment_id}/${response.razorpay_order_id}/${response.razorpay_signature}`
                    );
                },
                prefill: {
                    name: "",
                    email: "",
                    contact: "",
                },
                config: {
                 display: {
                     language:'hi',
                    blocks: {
                        banks: {
                        name: 'All payment methods',
                        instruments: [
                            {
                                method: 'upi'
                            },
                            {
                                method: 'wallet'
                            },
                            {
                                method: 'card'
                            },
                            {
                                method: 'netbanking'
                            },
                            
                        ],
                        },
                    },
                    hide:[
                        {
                            method:'emi'
                        }
                    ],
                    sequence: ['block.banks'],
                    preferences: {
                        show_default_blocks: false,
                    },
                    },
                },
                options: {
                    checkout: {
                        hidden: {
                            email: true,
                            contact: true
                        }
                    }
                },
                theme: {
                    color: "#005700",
                    //backdrop_color:'#005700'
                },
            },
        };
    },
   
    created() {
        this.orderId = this.$route.params.order_id;
        this.getOrderDetails();
        this.getOrderPurchaseSummary();
        localStorage.setItem("retry", 1);
        this.transactionDetails.key = process.env.VUE_APP_RAZORPAY_CLIENT_ID;
        this.transactionDetails.currency = process.env.VUE_APP_CURRENCY;
        //this.transactionDetails.name = process.env.VUE_APP_COMPANY_NAME;
        //this.transactionDetails.description = process.env.VUE_APP_COMPANY_DESC;
        this.transactionDetails.config.display.language = process.env.VUE_LANGUAGE;
       // this.transactionDetails.theme.color = "#005700";
    },
    methods: {
        gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },
        removeWebViewFromAndroid() {
            const moengageAttr={
                            ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            ApiStatus:'',
                            Origin:'Web',
                            Action:'BackPressed'
                }
            MoengageEventGenerator(MoengageEvents.OrderPageAction,moengageAttr);
            this.gtagEventHandler(MoengageEvents.OrderPageAction,moengageAttr);

            Android.finishWebView(); 
        },
        getOrderDetails() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    //   console.log(response.data);
                   
                    this.orderDetails.productId = response.data.product_orders[0].business_product.id;
                    this.orderDetails.quantity = response.data.product_orders[0].quantity;
                    this.orderDetails.fullName = response.data.delivery_info.full_name;
                    this.orderDetails.maxPrice=response.data.product_orders[0].maximum_retail_price,
                    this.orderDetails.sellingPrice=response.data.product_orders[0].selling_price,
                    this.orderDetails.shortId=response.data.short_id;
                    this.orderDetails.productName = response.data.product_orders[0].business_product.product_name;
                    this.orderDetails.address = response.data.delivery_info.display_text;
                    this.orderDetails.productImage = response.data.product_orders[0].business_product.images[0]?.image.thumbnail?response.data.product_orders[0].business_product.images[0].image.thumbnail:this.defaultImage;
                    this.orderDetails.measuringUnit = response.data.product_orders[0].business_product.measuring_unit?.display_text? response.data.product_orders[0].business_product.measuring_unit.display_text:'';
                    this.orderDetails.productSize = response.data.product_orders[0].business_product?.product_size? response.data.product_orders[0].business_product.product_size:'';
                    if (response.data.status !== "INITIATED") {
                        if(response.data.status =='PLACED'||response.data.status=='DELIVERED'){
                            this.showToast(
                                `आपका ऑर्डर पहले ही सफल हो चुका है। ऑर्डर संबंधित किसी भी जानकारी लिए कृपया ग्राहक सेवा प्रतिनिधि से +91-8068975594 पर संपर्क करें।`,
                                '#005700',
                                -1,
                                true,
                                '#005700',
                             
                            )
                        }
                        else if(response.data.status =='FAILED' || response.data.status=='CANCELLED'){
                            this.showToast(
                                `आपका ऑर्डर पहले सफल नहीं हुआ था। कृपया पीछे जाकर दोबारा ऑर्डर करें।अन्य किसी भी जानकारी लिए कृपया ग्राहक सेवा प्रतिनिधि से +91-8068975594 पर संपर्क करें।`,
                                'error',
                                -1,
                                true,
                                'error',
                                
                            )
                        }else if(response.data.status=='PENDING'){
                            this.showToast(`
                                आपका ऑर्डर की जानकारी अभी नहीं मिल पा रही है। कृपया प्रतीक्षा करें हम आपको कॉल करेंगे।अन्य किसी भी जानकारी लिए कृपया ग्राहक सेवा प्रतिनिधि से +91-8068975594 पर संपर्क करें।`,
                                '#e2a422',
                                -1,
                                true,
                                '#e2a422',
                                
                            )
                        }
                        this.isInitiated=false
                        //this.removeWebViewFromAndroid();
                        }
                    
                   //this.orderDetails.phoneNo = response.data.delivery_info.phone_number;
                    this.$store.dispatch('orderPaymentStore/setBrandDetails', response.data);
                    //  if(process.env.VUE_APP_MOENGAGE_ACTIVE !== "false"){
                    //     window?.Moengage.add_unique_user_id(response.data.user_id);
                    // }
                    
                }
            };

            const errorHandler = (error) => {
                console.log(error.response);
                if (error.response.status === 404) {
                    this.showToast("Invalid Order", "error");
                    this.loader(false);
                    //this.$router.replace({ name: "login" });
                    this.removeWebViewFromAndroid();
                } else {
                    this.showToast("Temporary Issue", "error");
                    this.loader(false);
                }
                this.loader(false);
            };

            this.requestGET(
                API_URL.order_getDetails + `/${this.orderId}/details`,
                {},
                {},
                successHandler,
                errorHandler
            );
        },
        getOrderPurchaseSummary() {
            this.loader = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    //console.log(response.data);
                    this.orderDetails.calculationInfo =
                        response.data.purchase_summary;
                    this.orderDetails.buttonText =
                        response.data.purchase_summary.submit_button_text;
                    this.orderDetails.payableAmount =
                        response.data.purchase_summary.payable_amount;
                         this.$store.dispatch('orderPaymentStore/setAmount', response.data.purchase_summary.payable_amount);
                    this.loader = false;
                }
            };

            const errorHandler = (error) => {
                console.log(error.data);
                //this.showToast("Temporary Issue", "error");
                this.loader = false;
                //this.$router.replace({ name: "login" });
            };

            this.requestGET(
                API_URL.order_getDetails + `/${this.orderId}/purchase_summary`,
                {},
                {},
                successHandler,
                errorHandler
            );
        },
        onInput(event) {
          if((event.length)<1){
             this.$refs.CoupounRef.reset();
             this.orderDetails.coupounVerified=''
          }
        },

        checkCoupounState(state) {
            this.appliedRules.push(this.rules.checkCoupoun);
            if (this.$refs.CoupounRef.validate()) {
                if (this.orderDetails.discountCoupon) {
                    if (state == "apply") {
                        const payload = {
                            coupon_code: this.orderDetails.discountCoupon,
                        };
                        this.applyRemoveCoupoun(payload,state);
                    } else {
                        const payload = {
                            coupon_code: null,
                        };
                        this.applyRemoveCoupoun(payload,state);
                    }
                } else {
                    // this.showToast(
                    //     "kripya valid कूपन वैलिड dale  हे|",
                    //     "error"
                    // );
                }
            }
        },

        applyRemoveCoupoun(payload,state) {
            this.loader = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                 //   console.log(response.data);
                    if (response.data.coupon_code) {
                        this.orderDetails.coupounVerified = 'valid';
                        this.orderDetails.discountCoupon=response.data.coupon_code;
                        //this.showToast("Coupoun Applied");
                    } else if (!response.data.coupon_code) {
                        this.orderDetails.coupounVerified = '';
                        this.orderDetails.discountCoupon = null;
                        //this.showToast("Coupoun Removed !");
                    }
                    this.loader = false;
                    this.getOrderPurchaseSummary();
                    const moengageAttr={
                            ProductId:this.orderDetails.productId,
                            ProductName:this.orderDetails.productName,
                            BrandName:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandName,
                            BrandId:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandId,
                            ActionName:state=='apply'?'CodeApplied':'CodeRemoved',
                            ApiStatus:response.status,
                            FieldEntered:this.orderDetails.discountCoupon,
                            Origin:'Web'
                        }
                        MoengageEventGenerator(MoengageEvents.CheckoutPageAction,moengageAttr);
                        this.$gtag.event(MoengageEvents.CheckoutPageAction,moengageAttr);
                }
            };

            const data = payload;

            const errorHandler = (error) => {
                console.log(error.response);
                if (error.response.status == 400) {
                    this.orderDetails.coupounVerified = 'notValid';
                    //this.showToast(error.response.data.errors, "error");
                } else if (error.response.status == 500) {
                    this.showToast("Temporary Issue", "error");
                     this.orderDetails.coupounVerified = '';
                } else {
                    this.showToast("Temporary Issue", "error");
                     this.orderDetails.coupounVerified = '';
                }
               
                this.loader = false;
                const moengageAttr={
                            ProductId:this.orderDetails.productId,
                            ProductName:this.orderDetails.productName,
                            BrandName:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandName,
                            BrandId:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandId,
                            ActionName:state=='apply'?'CodeApplied':'CodeRemoved',
                            ApiStatus:error.response.status,
                            FieldEntered:this.orderDetails.discountCoupon,
                            Origin:'Web'
                        }
                        MoengageEventGenerator(MoengageEvents.CheckoutPageAction,moengageAttr);
                        this.$gtag.event(MoengageEvents.CheckoutPageAction,moengageAttr);
            };

            this.requestPATCH(
                API_URL.order_getDetails + `/${this.orderId}/update`,
                data,
                {},
                successHandler,
                errorHandler
            );
        },

        updateQuantity(operation) {
            console.log(this.orderDetails.productId);
            if (operation == "minus" && this.orderDetails.quantity > 1) {
                this.orderDetails.quantity = this.orderDetails.quantity - 1;
            }
            if (operation == "add" && this.orderDetails.quantity > 0) {
                this.orderDetails.quantity = this.orderDetails.quantity + 1;
            }
            if (this.orderDetails.productId) {
                const payload = {
                    product_orders: [
                        {
                            business_product: this.orderDetails.productId,
                            quantity: this.orderDetails.quantity,
                        },
                    ],
                };
                this.updateOrderDetails(payload);
            }
        },
        updateOrderDetails(payload) {
            this.loader = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                 //   console.log(response.data);
                    this.loader = false;
                    this.getOrderPurchaseSummary();
                    
                        const moengageAttr={
                            ProductId:this.orderDetails.productId,
                            ProductName:this.orderDetails.productName,
                            BrandName:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandName,
                            BrandId:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandId,
                            ActionName:'QuantityChanged',
                            ApiStatus:response.status,
                            FieldEntered:this.orderDetails.quantity,
                            Origin:'Web'
                        }
                        MoengageEventGenerator(MoengageEvents.CheckoutPageAction,moengageAttr);
                        this.$gtag.event(MoengageEvents.CheckoutPageAction,moengageAttr);
                    }
            };

            const data = payload;

            const errorHandler = (error) => {
                console.log(error.response);
                 this.loader = false;
                 this.showToast("Temporary Issue", "error");
                 const moengageAttr={
                            ProductId:this.orderDetails.productId,
                            ProductName:this.orderDetails.productName,
                            BrandName:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandName,
                            BrandId:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandId,
                            ActionName:'QuantityChanged',
                            ApiStatus:error.response.status,
                            FieldEntered:this.orderDetails.quantity,
                            Origin:'Web'
                        }
                    MoengageEventGenerator(MoengageEvents.CheckoutPageAction,moengageAttr);
                    this.$gtag.event(MoengageEvents.CheckoutPageAction,moengageAttr);
                };

            this.requestPATCH(
                API_URL.order_getDetails + `/${this.orderId}/update`,
                data,
                {},
                successHandler,
                errorHandler
            );
        },

        verifyOrderDetails() {
            this.loader = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    if (response.data.status) {
                        sessionStorage.setItem('shortId',this.orderDetails.shortId);
                        const moengageAttr={
                            ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            ActionName:'PayNow',
                            ApiStatus:response.status,
                            FieldEntered:sessionStorage.getItem('amt'),
                            Origin:'Web'
                        }
                        MoengageEventGenerator(MoengageEvents.CheckoutPageAction,moengageAttr);
                        this.$gtag.event(MoengageEvents.CheckoutPageAction,moengageAttr);
                        this.paymentInitiate();
                        this.loader = false;
                    }
                }
            };

            const data = {
                order_id: this.orderId,
                payable_amount: this.orderDetails.payableAmount,
            };

            const errorHandler = (error) => {
                console.log(error.response);
                if (error.response.status == 406) {
                    this.showToast(error.response.data.errors, "error");
                } else {
                    this.showToast("Something went wrong ! ", "error");
                }
                const moengageAttr={
                    ProductId:sessionStorage.getItem('pid'),
                    ProductName:sessionStorage.getItem('pname'),
                    BrandName:sessionStorage.getItem('brand-name'),
                    BrandId:sessionStorage.getItem('brand-id'),
                    ActionName:'PayNow',
                    ApiStatus:error.response.status,
                    FieldEntered:sessionStorage.getItem('amt'),
                    Origin:'Web'
                }
                MoengageEventGenerator(MoengageEvents.CheckoutPageAction,moengageAttr);
                this.$gtag.event(MoengageEvents.CheckoutPageAction,moengageAttr);
                this.loader = false;
            };

            this.requestPOST(
                API_URL.order_verify,
                data,
                {},
                successHandler,
                errorHandler
            );
        },

        paymentInitiate() {
            this.loader = true;
            this.setOptions();
            const successHandler = (response) => {
                if (response.status === 200) {
                 //   console.log(response.data);
                    this.loader = false;
                    this.transactionDetails.order_id = response.data.payment_order_id;
                    //console.log("trans", this.transactionDetails);
                    
                    //razorpay window opening
                    // let razorpayWindow = window.Razorpay(
                    //     this.transactionDetails
                    // );
                    razorpayWindow.open();
                    razorpayWindow.on("payment.failed", function (response) {
                        console.log(response);
                        if (response.error.reason == "payment_pending") {
                           window.location.replace(`/payment-pending/${response.error.metadata.payment_id}/${response.error.metadata.order_id}/${response.error.reason}`);
                        } else if (
                            response.error.reason == "payment_failed" && localStorage.getItem("retry") > 2) {
                         window.location.replace(`/payment-failed/${response.error.metadata.payment_id}/${response.error.metadata.order_id}/${response.error.reason}`);
                        } else {
                            let retry = parseInt(localStorage.getItem("retry"));
                            localStorage.setItem("retry", retry + 1);
                        }
                    });
                }
            };

            const data = {
                order_id: this.orderId,
                payable_amount: this.orderDetails.payableAmount,
            };

            const errorHandler = (error) => {
                console.log(error.response);
                if (error.response.status == 406) {
                    this.showToast(error.response.data.errors, "error");
                } else {
                    this.showToast("Something went wrong ! ", "error");
                }
                this.loader = false;
            };

            this.requestPOST(
                API_URL.order_payment_initiate,
                data,
                {},
                successHandler,
                errorHandler
            );
        },

        paymentConfirmation(payload) {
            const successHandler = (response) => {
                if (response.status === 200) {
                    if (response.data.payment_status == "FAILED") {
                        this.$router.replace({ name: "paymentFailed" });
                    }
                }
            };

            const data = payload;

            const errorHandler = (error) => {
                console.log(error.data);
                this.showToast(error.response.data.errors, "error");
            };

            this.requestPOST(
                API_URL.order_payment_confirmation,
                data,
                {},
                successHandler,
                errorHandler
            );
        },

        setOptions() {
            this.transactionDetails.amount = this.orderDetails.payableAmount;
            this.transactionDetails.prefill.name = this.orderDetails.fullName;
            this.transactionDetails.prefill.contact = this.orderDetails.phoneNo;
        },

        razorpay() {
            this.verifyOrderDetails();
        },
        onFocusInput(){
            const moengageAttr={
                ProductId:this.orderDetails.productId,
                ProductName:this.orderDetails.productName,
                BrandName:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandName,
                BrandId:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandId,
                ActionName:'EnterCode',
                ApiStatus:'',
                FieldEntered:this.orderDetails.discountCoupon,
                Origin:'Web'
            }
            MoengageEventGenerator(MoengageEvents.CheckoutPageAction,moengageAttr);
            this.$gtag.event(MoengageEvents.CheckoutPageAction,moengageAttr);
        },
        // checkIsEmpty(){
        //     console.log(this.orderDetails.discountCoupon)
        // }
    },
};
</script>

<style scoped>

.header {
    background-color: #005700;
}

.headerText {
    color: white;
    padding: 4px;
    font-weight: 500;
    font-size: 18px;
    margin-left: 1rem;
    padding-top: 18px;
}

.imageGrid {
    justify-content: left;
    align-items: flex-start;

    padding-top: 1rem;
}

.whitebackgrnd {
    background-color: white;
    padding: 4px;
    margin-left: 1rem;
    margin-right: 1rem;
}

.imageBox {
    width: 40%;
}

.imgBorder {
    border: 1px solid #a6aca9;
    border-radius: 4px;
    height: 100px;
    width: 100px;
}

.desc {
    width: 60%;
    font-size: 18px;
    margin-right: 1rem;
    word-wrap: break-word;
}

.greytext {
    color: #707070;
    font-size: 16px;
    font-weight: 500;
}

.greentext {
    color: #00570d;
    font-size: 16px;
    font-weight: 500;
}

.coupounBox {
    transform: translateY(-62px);
    color: green;
    font-size: 16px;
    font-weight: 600;
}

.textBox {
    font-size:16px;
    font-weight: 600;
}

.boldText {
    font-size: 18px;
    font-weight: 600;
}
.payButton{
       position: fixed;
        top: calc(100vh-0);
        bottom: 0;
        width:100%
}
.productPrice{
        font-size: 16px;
        margin: -15px 0px 0px 0px;
}
.buy{
    font-weight: 500;
    font-size: 18px
}
.deliveryText{
    font-size: 17px;
    font-weight: 600   
}
.address{
    display: flex;
    flex-direction: column;
    font-weight: 400;
    font-size: 18px !important;
    justify-content: flex-start;
    margin-top:-14px
}

@media all and (max-width: 344px) {
    .imageBox {
        width: 35%;
        margin-right: 0.6rem;
      
    }

    .desc {
        width: 100%;
        font-size: 15px;
        margin-right: 0.2rem;
        word-wrap:normal;
    }

    .imageGrid {
        justify-content: left;
        align-items: flex-start;

        padding-top: 1rem;
    }

    .imgBorder {
        border: 1px solid #a6aca9;
        border-radius: 4px;
        height: 80px;
        width: 70px;
    }

    .coupounBox {
        transform: translateY(-60px);
        color: green;
        font-size: 14px !important;
        font-weight: 600;
    }

    .textBox {
        font-size: 14px;
        font-weight: 600;
    }

    .boldText {
        font-size: 16px;
        font-weight: 600;
    }

    .greytext {
        color: #707070;
        font-size: 14px;
        font-weight: 500;
    }

    .greentext {
        color: #00570d;
        font-size: 14px;
        font-weight: 500;
    }
    .productPrice{
        font-size: 15px !important;
        margin: -15px 0px 0px 0px;
    }
    .buy{
        font-weight: 500;
        font-size: 16px !important
    }
    .deliveryText{
        font-size: 15px !important;
        font-weight: 600   
    }
    
}
@media all and (max-width: 343px){
    .desc{
        /* font-size: 14px; */
    }
    .productPrice{
        font-size: 13px !important;
        margin: -15px 0px 0px 0px;
    }
    .coupounBox {
        transform: translateY(-60px);
        color: green;
        font-size: 14px !important;
        font-weight: 600;
    }
    
}
</style>
